export function mapStepsToDegree(step:number):number{
    let degree = 0;
    switch (step) {
        case 1:
            degree = 90;
            break;
        case 2:
            degree = 180;
            break;
        case 3:
            degree = 270;
            break;    
        default:
            break;
    }
    return degree;
}